/**
 * Menu script
 */
class MM_Menu {
    constructor() {
        this.initState();
        this.initEvents();
    }

    initState() {
        this.win = $(window);
        this.menuWrapper = $('.site-header');
        this.menuIcon = this.menuWrapper.find('.menu-toggle');
        this.menu = this.menuWrapper.find('.menu-block');
        this.menuItemSubmenu = this.menu.find('.menu-item.menu-item-has-children');
        this.mobileViewport = window.matchMedia("screen and (max-width: 1040px)");
    }

    initEvents() {
        this.menuItemSubmenu.append( "<span class='arrow'></span>" );

        $(window).on('scroll', () => {
            let positionY = this.win.scrollTop();

            if (positionY > 25 && !this.menuWrapper.hasClass('is-fixed')) {
                this.menuWrapper.addClass('is-fixed');
                return;
            }

            if (positionY <= 25 && this.menuWrapper.hasClass('is-fixed')) {
                this.menuWrapper.removeClass('is-fixed');
            }
        });

        if (this.mobileViewport.matches) {
            this.openMobileMenu();
        }

        this.mobileViewport.addListener((mq) => {
            if (mq.matches) {
                this.openMobileMenu();
            } else {
                this.menu.removeClass('is-showing');
                this.menuIcon.removeClass('is-active');
                this.menuIcon.attr('aria-expanded', 'false');
                $('.menu-item').removeClass('is-active');
                $(document.body).removeClass('no-scroll');

                setTimeout(() => {
                    this.menu.removeClass('is-active');
                }, 150);
            }
        });

        this.initDynamicBgHeight();
    }

    initDynamicBgHeight () {
        let firstLevelItemsWithChildren = $('#main-menu').children('li.menu-item-has-children');
        
        for (let i = 0; i < firstLevelItemsWithChildren.length; i++) {
            this.recursiveChildrenCounter(firstLevelItemsWithChildren.eq(i), 0);
            let submenuBg = firstLevelItemsWithChildren.eq(i).children('.sub-menu');
            let allSubElementsWithChildrenCount = firstLevelItemsWithChildren.eq(i).find('li[data-children-count]');
            let currentHeight = 0;
            let currentLevel = 0;

            firstLevelItemsWithChildren.eq(i).on('mouseenter', function () {
                let newHeight = parseInt($(this).attr('data-children-count'), 10);
                let newLevel = parseInt($(this).attr('data-children-level'), 10);
                
                if (newHeight > currentHeight && newLevel >= currentLevel) {
                    currentHeight = newHeight;
                    submenuBg.attr('data-bg-height', newHeight);
                } else if (newHeight < currentHeight && newLevel < currentLevel) {
                    currentHeight = newHeight;
                    submenuBg.attr('data-bg-height', newHeight);
                }

                currentLevel = newLevel;
            });

            for (let j = 0; j < allSubElementsWithChildrenCount.length; j++) {
                allSubElementsWithChildrenCount.on('mouseenter', function () {
                    let newHeight = parseInt($(this).attr('data-children-count'), 10);
                    let newLevel = parseInt($(this).attr('data-children-level'), 10);
                    
                    if (newHeight > currentHeight && newLevel >= currentLevel) {
                        currentHeight = newHeight;
                        submenuBg.attr('data-bg-height', newHeight);
                    } else if (newHeight < currentHeight && newLevel <= currentLevel) {
                        currentHeight = newHeight;
                        submenuBg.attr('data-bg-height', newHeight);
                    }

                    currentLevel = newLevel;
                });
            }
        }
    }

    recursiveChildrenCounter (parent, level, parentHeight = 0) {
        let children = parent.children('.sub-menu').eq(0).children('li');
        let hasPromotedProducts = parent.children('.menu-promoted-products');
        parent.attr('data-children-level', level);

        if (hasPromotedProducts.length) {
            parent.attr('data-children-count', 5);
        } else {
            parent.attr('data-children-count', children.length);

            if (children.length === 0) {
                parent.attr('data-children-count', parentHeight);
            }
        }

        for (let i = 0; i < children.length; i++) {
            this.recursiveChildrenCounter(children.eq(i), level + 1, children.length);
        }
    }

    openMobileMenu () {
        if (this.menuWrapper.attr('data-is-initialized')) {
            return;
        }

        this.menuWrapper.attr('data-is-initialized', 'true');

        setTimeout(() => {
            this.menuSubmenuToggle = this.menuItemSubmenu.find('.arrow');

            this.menuSubmenuToggle.each(function(i, item) {
                $(item).on('click', function() {
                    $(item).parent().toggleClass('is-active');
                });
            });
        }, 0);

        if (this.menuIcon.length) {
            this.menuIcon.on('click', e => {
                e.preventDefault();
                let menuIconValue = this.menuIcon.attr('aria-expanded');
                this.menu.toggleClass('is-active');
                this.menuIcon.toggleClass('is-active');
                this.menuIcon.attr('aria-expanded', 'true');
                $(document.body).toggleClass('no-scroll');

                if ( menuIconValue === 'true') {
                    this.menuIcon.attr('aria-expanded', 'false');
                }

                setTimeout(() => {
                    this.menu.toggleClass('is-showing');
                }, 150);
            });
        }
    }
}
